import { defineMessage } from 'services/localization';

export const messages = {
    itemName: defineMessage('items'),
    supplierName: defineMessage('supplier'),
    billsReferenceName: defineMessage('bills_reference'),
    dateName: defineMessage('date'),
    dueDateName: defineMessage('due_date'),
    amountDueName: defineMessage('amount_due'),
    payment: defineMessage('payment_currency_1'),
    code: defineMessage('code'),
    particulars: defineMessage('particulars'),
    reference: defineMessage('reference'),
    details: defineMessage('details'),
    bankAccountName: defineMessage('bank_account'),
};
